import { deckStats } from '../../store'

interface ManaCurveProps {
  maxCost?: number
}

export function ManaCurve({ maxCost = 10 }: ManaCurveProps) {
  const stats = deckStats()

  if (!stats) {
    return (
      <div className="bg-gray-800 rounded-lg p-4">
        <h3 className="text-white font-semibold mb-3">Curva de Maná</h3>
        <p className="text-gray-400 text-sm">No hay cartas en el mazo</p>
      </div>
    )
  }

  const costData = []
  let totalCards = 0
  for (let i = 0; i <= maxCost; i++) {
    const count = stats.costCurve[i] || 0
    costData.push({ cost: i, count })
    totalCards += count
  }

  const maxCount = Math.max(...costData.map((d) => d.count), 1)

  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <h3 className="text-white font-semibold mb-3">Curva de Maná</h3>
      <div className="flex items-end justify-between gap-1 h-32">
        {costData.map((data) => {
          const percentage = totalCards > 0 ? (data.count / totalCards) * 100 : 0
          const heightPercent = (data.count / maxCount) * 100
          return (
            <div key={data.cost} className="flex-1 flex flex-col items-center gap-1">
              <div
                className={`w-full rounded-t transition-all ${
                  data.cost <= 3
                    ? 'bg-green-500'
                    : data.cost <= 5
                    ? 'bg-yellow-500'
                    : 'bg-red-500'
                } ${data.count === 0 ? 'opacity-20' : ''}`}
                style={{ height: `${Math.max(heightPercent, 4)}%` }}
              />
              <span className="text-xs text-gray-400">{data.cost}</span>
            </div>
          )
        })}
      </div>
      <div className="mt-2 flex justify-center gap-4 text-xs text-gray-500">
        <span>0-3: {costData.slice(0, 4).reduce((s, d) => s + d.count, 0)}</span>
        <span>4-5: {costData.slice(4, 6).reduce((s, d) => s + d.count, 0)}</span>
        <span>6+: {costData.slice(6).reduce((s, d) => s + d.count, 0)}</span>
      </div>
    </div>
  )
}
